import { createSelector } from '@ngrx/store';

import { getProductsList } from '@features/products/productsArray/infrastructure/state/productsArray.selectors';
import { WishlistPublicSelectors } from '@features/wishlist';
import { getProductsId } from '@pages/category/store/category-page.selectors';
import { getProductPageDetail } from '@pages/product';
import { SearchSelectors } from '@pages/search';
import { getRelatedProductsPlaces } from '@shared/product/related-products/infrastructure/state/related-products.selectors';
import { getShopCartCoreItems } from '@shared/shopcart-core/infrastructure/state/shopcart-core.selectors';

export const getGridPageProductsFiltered = createSelector(getProductsId, (productsId) => productsId);

/** Deberá contener los mismos selectores que los definidos en la generación de selectores para la propiedad listPosition */
export const getIndexCalculationValues = createSelector(
    getShopCartCoreItems,
    getGridPageProductsFiltered,
    getProductPageDetail,
    getProductsList,
    getRelatedProductsPlaces,
    SearchSelectors.getQueryResults,
    WishlistPublicSelectors.getWishlistItems,
    (
        cartItems,
        filteredProductsIds,
        productPageProduct,
        productsArray,
        relatedProductsPlaces,
        queryResults,
        wishListItems,
    ) => {
        return {
            cartItems,
            filteredProductsIds,
            productPageProduct,
            productsArray,
            queryResults,
            relatedProductsPlaces,
            wishListItems,
        };
    }
);
